// import React from 'react';
import { useRef } from 'react';
import { useToggle, useFullscreen } from 'react-use';
import classNames from 'classnames';

import './FullScreen.css';

const FullScreen = () => {
  const ref = useRef(document.body);

  const [show, toggle] = useToggle(false);
  const isFullscreen = useFullscreen(ref, show, { onClose: () => toggle(false) });

  return (
    <div className="header__widget ">
      {/* <src img={} alt="full screen button" className="header__widget--fullScreen" /> */}

      <div
        className={classNames('header__widget--fullScreen', {
          'widget--can-enter-fullScreen': !isFullscreen,
          'widget--can-quit-fullScreen': isFullscreen,
        })}
        onClick={() => toggle()}
      />
    </div>
  );
};

export default FullScreen;
